import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html } from "lit";
import { styleMap } from "lit-html/directives/style-map.js";
import "../../atom/Sennder/Isotype/index.js";
import "../../atom/Sennder/Logotype/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfLogo = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_variant = "primary";
    this.dsf_mobile = false;
    this.dsf_title = "";
  }
  render() {
    let intencity = 400;
    if (this.dsf_variant === "dark") {
      intencity = 600;
    } else if (this.dsf_variant === "light") {
      intencity = 0;
    }
    const style = styleMap({
      fontSize: this.dsf_mobile ? "7px" : "9px",
      textTransform: "uppercase",
      lineHeight: "16px",
      color: `rgb(var(--dsf-color-neutral-${intencity}))`
    });
    const isotype = html`<dsf-isotype dsf_variant=${this.dsf_variant}></dsf-isotype>`;
    if (this.dsf_mobile) {
      return html`
        <div class="flex flex-col items-center">
          ${isotype}
          <span class="dsf-text-xxs-semibold text-neutral-400" style=${style}
            >${this.dsf_title}</span
          >
        </div>
      `;
    }
    return html`
      <div class="flex flex-row gap-12">
        ${isotype}
        <div class="flex flex-col">
          <dsf-logotype dsf_variant=${this.dsf_variant}></dsf-logotype>
          <span class="dsf-text-xxs-semibold text-neutral-400" style=${style}
            >${this.dsf_title}</span
          >
        </div>
      </div>
    `;
  }
};
__decorateClass([
  prop({ type: String })
], DsfLogo.prototype, "dsf_variant", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfLogo.prototype, "dsf_mobile", 2);
__decorateClass([
  prop({ type: String })
], DsfLogo.prototype, "dsf_title", 2);
DsfLogo = __decorateClass([
  defineElement("dsf-logo")
], DsfLogo);
export {
  DsfLogo
};
